import { mailTemplates } from './mailTemplates';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getApp } from 'firebase/app';

export const sendMailTemplate = async <T extends keyof typeof mailTemplates>(
  to: string,
  templateName: T,
  params: Parameters<(typeof mailTemplates)[T]>[0]
): Promise<boolean> => {
  try {
    const template = mailTemplates[templateName];
    const { subject, html } = await template(params as any);
    
    // Get Firestore instance from the client-side Firebase app
    const db = getFirestore(getApp());
    
    // Simplest possible email data without attachments
    const emailData = {
      to,
      message: {
        subject,
        html,
        text: `Please view this email in an HTML-compatible email client.`
      }
    };
    
    // Add the email to the mail collection
    await addDoc(collection(db, "mail"), emailData);
    
    console.log('Email data sent to Firestore (without attachment):', {
      to,
      subject
    });
    
    return true;
  } catch (error) {
    console.error("Error sending email:", error);
    return false;
  }
}; 